import React from "react";
import Button from "@mui/material/Button";

const ResetButton = ({ children }: { children: string }) => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Button variant="contained" style={{ backgroundColor: 'white', color: 'black', textTransform: 'none' }} onClick={handleReload}>
      {children}
    </Button>
  );
};

export default ResetButton;
